import React from 'react'

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

import logo_hyundai from './../../UI/carSlider/logo_hyundai.svg'
import arrow from './../../UI/general/arrow.svg'
import arrowBtn from './../../UI/general/arrow_btn.svg'

import GetBrowserInfo from '../../helpers/GetBrowserInfo';
import { getSliderData, getConfigData } from '../../helpers/strapi.helper';

declare const window: any;

interface CarSliderMobile {
  absoluteContainer: any
  browserInfo: any
}

interface Props {
  openCarSlider: boolean,
  handleOpenCarStudio: (payload: string) => void
  handleTouchScreen: () => void
}

interface State {
  carSelected: string,
  slider: any,
  selectedCarIndex: number,
  backgroundColor: string,
  transitionTime: number
}

class CarSliderMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      carSelected: '',
      slider: {},
      selectedCarIndex: 1,
      backgroundColor: '#000000',
      transitionTime: 500
    }
    this.absoluteContainer = React.createRef()
    this.browserInfo = GetBrowserInfo()
  }

  componentDidMount(): void {
    const rawSlider: any = getSliderData()
    const sortedKeys = Object.keys(rawSlider).sort((a, b) => (rawSlider[a].orden ?? 999) - (rawSlider[b].orden ?? 999));
    const slider: any = {} as any;
    sortedKeys.forEach(k => { slider[k] = rawSlider[k]; });
    const carSelected = sortedKeys[0];
    this.setState({
      carSelected: carSelected,
      slider: slider,
      backgroundColor: slider[carSelected].bgColor,
      selectedCarIndex: 0
    });

    this.absoluteContainer = document.querySelector<HTMLElement>('.car-slider-general-container')
    this.configureStyle(slider[carSelected].bgColor, "0.5s")
    /*if (absoluteLogo != null){
      absoluteLogo.style.setProperty('--carousel-background', slider[carSelected].bgColor)
      absoluteLogo.style.setProperty('--carousel-transition', "0.5s")
    }*/
  
    window.addEventListener('touchstart', this.props.handleTouchScreen)
    // Verifica que dataLayer y dataLayer.comp_core estén definidos antes de usarlos
    
    if (window.dataLayer && window.dataLayer.comp_core) {
      window.dataLayer.push({
        'event': 'hero_banner_view',
        'comp_page': {
          'name_banner': carSelected.toLowerCase(),
          'link': "https://www.hyundaicolombia.co/interactive-car-studio/"
        }
      });
    } else {
      console.error("dataLayer or dataLayer.comp_core is not defined");
    }
  }

  componentWillUnmount(): void {
    window.removeEventListener('touchstart', this.props.handleTouchScreen)
  }

  handlePrevCar = () => {
    if(this.browserInfo.isBrowserSafari === true && this.browserInfo.isOSMacOS){
      if((this.state.selectedCarIndex - 1) >= 0){
        this.setState({
          transitionTime: 500,
        }, () => {
          this.setState({
            selectedCarIndex: this.state.selectedCarIndex -1 
          })
        })
      }else{
        this.setState({
          transitionTime: 2000,
        }, () => {
          this.configureStyle(null, "2.0s")
          this.setState({
            selectedCarIndex: Object.keys(this.state.slider).length - 1
          })
          setTimeout(() => {
            this.configureStyle(null, "0.5s")
            this.setState({
              transitionTime: 500,
            })
          }, 2000)
        })
      }
    }else{
      const element = document.querySelector<HTMLElement>('.slide.selected')
      if(element !== null){
        this.SimulateSwipe(element, 0, 0, 100, 0, 50); // Swipe from (0, 00) to (100, 0) over 100ms
      }
    }
  }

  handleNextCar = () => {
    if(this.browserInfo.isBrowserSafari === true && this.browserInfo.isOSMacOS){
      if((this.state.selectedCarIndex + 1) >= Object.keys(this.state.slider).length){
        this.setState({
          transitionTime: 2000,
        }, () => {
          this.configureStyle(null, "2.0s")
          this.setState({
            selectedCarIndex: 0
          })
          setTimeout(() => {
            this.configureStyle(null, "0.5s")
            this.setState({
              transitionTime: 500,
            })
          }, 2000)
        })
      }
      else{
        this.setState({
          transitionTime: 500,
        }, () => {
          this.setState({
            selectedCarIndex: this.state.selectedCarIndex + 1
          })
        })
      }
    }else{
      const element = document.querySelector<HTMLElement>('.slide.selected')
      if(element !== null){
        this.SimulateSwipe(element, 100, 0, 0, 0, 50); // Swipe from (100, 00) to (0, 0) over 100ms
      }
    }
  }
  
  SimulateSwipe(element: HTMLElement, startX: number, startY: number, endX: number, endY: number, duration: number): void {
    // Function to create a touch object
    const createTouch = (x: number, y: number): Touch => {
      return new Touch({
        identifier: Date.now(),
        target: element,
        clientX: x,
        clientY: y,
        radiusX: 2.5,
        radiusY: 2.5,
        rotationAngle: 0,
        force: 0.5,
        pageX: x,
        pageY: y,
        screenX: x,
        screenY: y
      });
    };
  
    // Create touch start event
    const startTouch = createTouch(startX, startY);
    const touchStartEvent = new TouchEvent('touchstart', {
      bubbles: true,
      touches: [startTouch],
      targetTouches: [startTouch],
      changedTouches: [startTouch],
    });
    element.dispatchEvent(touchStartEvent);
  
    // Function to move the touch from start to end
    const moveTouch = (x: number, y: number) => {
      const moveTouch = createTouch(x, y);
      const touchMoveEvent = new TouchEvent('touchmove', {
        bubbles: true,
        touches: [moveTouch],
        targetTouches: [moveTouch],
        changedTouches: [moveTouch],
      });
      element.dispatchEvent(touchMoveEvent);
    };
  
    // Simulate the movement by incrementing/decrementing the x, y values over the duration
    const steps = 10;
    /*const dx = (endX - startX) / steps;
    const dy = (endY - startY) / steps;
    let currentX = startX;
    let currentY = startY;*/
  
    for (let i = 1; i <= steps; i++) {
      setTimeout(() => {
        const currentX = startX + i*(endX - startX) / steps;
        const currentY = startY + i*(endX - startX) / steps;
        moveTouch(currentX, currentY);
        if (i === steps) {
          // Create touch end event
          const endTouch = createTouch(endX, endY);
          const touchEndEvent = new TouchEvent('touchend', {
            bubbles: true,
            touches: [endTouch],
            targetTouches: [],
            changedTouches: [endTouch],
          });
          element.dispatchEvent(touchEndEvent);
        }
      }, (duration / steps) * i);
    }
  }

  handleViewSelectCar = () => {
    //console.log("car selected: "+this.state.carSelected);
    let absoluteLogo = document.querySelector<HTMLElement>('.car-slider-general-container-mobile')
    if (absoluteLogo != null){
      absoluteLogo.style.setProperty('--carousel-background', this.state.backgroundColor)
      absoluteLogo.style.setProperty('--carousel-transition', "0.5s")
    }
    window.dataLayer.push({
      'event': 'hero_banner_view',
      'comp_page': {
      'name_banner': this.state.carSelected.toLowerCase(),
      'link': "https://www.hyundaicolombia.co/interactive-car-studio/"
      }
    })
    
  }

  configureStyle = (backgroundColor: any, transitionTime: any) => {
    if (this.absoluteContainer == null)
      return;
    if(backgroundColor)
      this.absoluteContainer.style.setProperty('--carousel-background', backgroundColor)
    
    if(transitionTime)
      this.absoluteContainer.style.setProperty('--carousel-transition', transitionTime)
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.openCarSlider ? 'car-slider-container-mobile fade-in':'car-slider-container-mobile fade-out'}>
          <div className='car-slider-general-container-mobile' style={{background: this.state.backgroundColor}}>
            <Carousel
              emulateTouch={true} 
              infiniteLoop={true}
              showStatus={false} 
              showThumbs={false} 
              selectedItem={this.state.selectedCarIndex} 
              showArrows={false} 
              useKeyboardArrows={true}
              onChange={(e) => {
                const slider: any = this.state.slider
                this.setState({
                  carSelected: Object.keys(slider)[e],
                  backgroundColor: slider[Object.keys(slider)[e]].bgColor,
                  selectedCarIndex: e
                }, () => this.handleViewSelectCar())
              }}
            >
              {
                Object.keys(this.state.slider).map((slider: any, index: number) => 
                <div className='main-car-slider-container-mobile' key={slider + index} style={{
                  //backgroundColor: this.state.slider[slider].bgColor
                }}>
                  <div className='car-slider-individual-container-mobile'>
                    <div className='car-slider-main-title-mobile'>
                      {
                        this.state.slider[slider].nameTitle
                      }
                    </div>
                    <div className='car-slider-title-bg-mobile'>
                      {
                        this.state.slider[slider].nameAlt
                      }
                    </div>
                    {/* <div className='car-image-container-mobile'>
                      {this.state.slider[slider].preview ?
                        <img src={this.state.slider[slider].preview} alt=''/>:
                        <div className='proximamente-container-mobile'>
                          PRÓXIMAMENTE
                        </div>
                      }
                    </div> */}
                    {this.state.slider[slider].preview ? 
                      <div className='car-image-container-mobile'> <img src={this.state.slider[slider].preview} alt=''/> </div> :
                      <div className='proximamente-container-mobile'>PRÓXIMAMENTE</div>
                    }
                    {this.state.slider[slider].info ? 
                      <div className='car-info-container-mobile'> <img src={this.state.slider[slider].info} alt=''/> </div> : ''
                    }
                    {this.state.slider[slider].preview ?
                      <div className='select-car-btn-mobile' id='element-umbra-analytics' data-type={"MODELO"} data-value={this.state.slider[slider].name} 
                      onMouseDown={(e) => e.stopPropagation()}
                      onTouchStart={(e) => e.stopPropagation()}
                      onPointerDown={(e) => e.stopPropagation()}
                      onClick={() => {
                      this.props.handleOpenCarStudio(this.state.slider[slider].name)
                    }}>
                      <div id='element-umbra-analytics' data-type={"MODELO"} data-value={this.state.slider[slider].name}>Conocer</div>
                      <img id='element-umbra-analytics' data-type={"MODELO"} data-value={this.state.slider[slider].name} src={arrowBtn} alt=''/>
                      </div>:null
                    }
                  </div>
                </div>
                )
              }
            </Carousel>
          </div>
          <div className='car-slider-logo-mobile'>
            <img src={logo_hyundai} alt=''/>
          </div>
          <div className='car-slider-hr'/>
          <div className='prev-container' onClick={() => {this.handlePrevCar()}}>
            <img src={arrow} alt=''/>
          </div>
          <div className='next-container' onClick={() => {this.handleNextCar()}}>
            <img src={arrow} alt=''/>
          </div>
          <div className='texto-legal-container-mobile'>
            <div>{getConfigData().texto_legal}</div>
          </div>
        </div>
      )
  }
}

export default CarSliderMobile